module.exports = __webpack_public_path__ + "static/media/connected-sticker-ENGIE.4bd1395f.png";